import { useContext } from 'react';
import { MenuItem, SplitButton } from 'react-bootstrap';
import { NavItemWrapper, NavWrapper } from './styles';
import { RecipientAction, MatchStatus, PatientType, MenuLocation } from '@nkr/enums/index';
import { AfterAction, RecipientProfileContext, editNavKey } from './models';
import ActionButtonRenderer from './action-button-renderer';

interface IProps {
    showButtons: boolean,
    onTabClick: (href: string) => void,
    onSave: (afterAction: AfterAction) => void
}

const RecipientProfileSaveRow = (props: IProps) => {
    const context = useContext(RecipientProfileContext);

    const hrefPrefix = 'center/' + context.centerId + '/recipient/' + context.recipientId + '/profile';

    const handleMenuToggle = (show: boolean) => {
    };

    const handleAction = (id: number, action: RecipientAction) => {
        if (action == RecipientAction.Edit) {
            window.location.href = '/center/' + context.centerId + '/recipient/' + id + '/profile/general';
        }

        if (action == RecipientAction.PairedDonors) {
            window.location.href = `center/${context.centerId}/donors/swap?center=${context.centerId}&status[]=active&status[]=inactive&status[]=donated&type[]=bridge&type[]=dd&type[]=paired&dob=`;
        }

        if (action == RecipientAction.Toolbox) {
            window.location.href = `center/${context.centerId}/recipient/${id}/toolbox`;
        }

        if (action == RecipientAction.PotentialDonors) {
            window.location.href = '/center/' + context.centerId + '/recipient/' + id + '/potential-donors';
        }

        if (action == RecipientAction.Order3gTissueTyping) {
            window.location.href = `/center/${context.centerId}/cheek-swab-request/recipient/${id}`;
        }

        if (action == RecipientAction.UtilizeBulkCheekSwab) {
            window.location.href = __OUTSIDEURL__ + '/centers/histogenetics/bulk-recipient-cheek-swab.php?recpId=' + id;
        }

        if (action == RecipientAction.ReprintRequisition) {
            context.onItemSelected(context.headerInfo.requisitionId, RecipientAction.ReprintRequisition)
        }
    };
    
    if (context.headerInfo == null)
        return null;

    return (
        <div style={{ display: 'flex', justifyContent: props.showButtons ? 'space-between' : 'flex-end', alignItems: 'center', borderBottom: props.showButtons ? '1px solid #ccc' : '' }}>
            {props.showButtons && (
                <NavWrapper bsStyle="tabs" activeKey={context.activeKey} style={{ borderBottom: 'none' }}>
                    <NavItemWrapper eventKey={editNavKey.GENERAL}
                        active={context.activeKey == editNavKey.GENERAL}
                        onClick={() => props.onTabClick(hrefPrefix + '/general')}
                    >
                        Recipient Data
                    </NavItemWrapper>

                    <NavItemWrapper eventKey={editNavKey.CONTACT_INFORMATION}
                        active={context.activeKey == editNavKey.CONTACT_INFORMATION}
                        onClick={() => props.onTabClick(hrefPrefix + '/contact-info')}
                    >
                        Recipient Address
                    </NavItemWrapper>

                    <NavItemWrapper eventKey={editNavKey.MEDICAL_DETAILS}
                        active={context.activeKey == editNavKey.MEDICAL_DETAILS}
                        onClick={() => props.onTabClick(hrefPrefix + '/med-details')}
                    >
                        Medical Details
                    </NavItemWrapper>

                    <NavItemWrapper eventKey={editNavKey.HLA_INFORMATION}
                        active={context.activeKey == editNavKey.HLA_INFORMATION}
                        onClick={() => props.onTabClick(hrefPrefix + '/hla-info')}
                    >
                        HLA Info
                    </NavItemWrapper>

                    <NavItemWrapper eventKey={editNavKey.RECORDS}
                        active={context.activeKey == editNavKey.RECORDS}
                        onClick={() => props.onTabClick(hrefPrefix + '/records')}
                    >
                        Records
                    </NavItemWrapper>

                    <NavItemWrapper eventKey={editNavKey.FINANCIAL_INFORMATION}
                        active={context.activeKey == editNavKey.FINANCIAL_INFORMATION}
                        onClick={() => props.onTabClick(hrefPrefix + '/fin-info')}
                    >
                        Financial Info
                    </NavItemWrapper>

                    <NavItemWrapper eventKey={editNavKey.ACTIVITY_LOG}
                        active={context.activeKey == editNavKey.ACTIVITY_LOG}
                        onClick={() => props.onTabClick(hrefPrefix + '/activity-log')}
                    >
                        XM/Activity Logs
                    </NavItemWrapper>

                    <NavItemWrapper eventKey={editNavKey.DONOR_DECLINES}
                        active={context.activeKey == editNavKey.DONOR_DECLINES}
                        onClick={() => props.onTabClick(hrefPrefix + '/donor-declines')}
                    >
                        Donor Declines
                    </NavItemWrapper>

                    <NavItemWrapper eventKey={editNavKey.ANTIBODY_SCREENINGS}
                        active={context.activeKey == editNavKey.ANTIBODY_SCREENINGS}
                        onClick={() => props.onTabClick(hrefPrefix + '/antibody-screening')}
                    >
                        Antibody Screening
                    </NavItemWrapper>

                    <NavItemWrapper eventKey={editNavKey.PAIRED_DONORS}
                        active={context.activeKey == editNavKey.PAIRED_DONORS}
                        onClick={() => props.onTabClick(hrefPrefix + '/paired-donors')}
                    >
                        Paired Donors
                    </NavItemWrapper>

                    {context.headerInfo.statusId == MatchStatus.Transplanted && (
                        <NavItemWrapper eventKey={editNavKey.POST_TRANSPLANT}
                            active={context.activeKey == editNavKey.POST_TRANSPLANT}
                            onClick={() => props.onTabClick(hrefPrefix + '/post-transplant')}
                        >
                            Post TXP
                        </NavItemWrapper>
                    )}
                </NavWrapper>
            )}

            {context.hasChanges && props.showButtons && (
                <div style={{ backgroundColor: 'greenyellow', color: '#333', padding: 3, textAlign: 'center', lineHeight: 1, fontSize: 12, borderRadius: 4 }}>
                    This page contains<br />pending changes
                </div>
            )}

            <div style={{ display: 'flex', alignItems: 'center', justifyContent: props.showButtons ? 'none' : 'flex-end' }}>
                <div style={{ paddingRight: 5, minWidth: 150, marginLeft: 'auto' }}>
                    <SplitButton id='recipient-profile-save-button' key={'recipient-profile-save'} bsStyle='primary' disabled={context.hasChanges == false && !context.isAdmin && !context.allowSaveWithNoChanges} title='Save Changes' onClick={() => props.onSave(null)} onSelect={(e: any) => props.onSave(e)}>
                        <MenuItem eventKey={AfterAction.Print}>Save &amp; Print</MenuItem>
                        <MenuItem eventKey={AfterAction.Email}>Save &amp; Email</MenuItem>
                        <MenuItem eventKey={AfterAction.AddDonor}>Save &amp; Add Donor</MenuItem>
                    </SplitButton>
                </div>

                <ActionButtonRenderer
                    recipientId={context.recipientId}
                    centerId={context.centerId}
                    hasMedicareAb={context.headerInfo.hasMedicareAb}
                    centerHasRecipientShield={context.headerInfo.centerHasRecipientShield}
                    recipientShieldEnrolled={context.headerInfo.recipientShieldEnrolled}
                    statusId={context.headerInfo.statusId}
                    orderId={context.headerInfo.requisitionId}
                    isAdmin={false}
                    isAdminLogin={context.isAdmin}
                    menuLocation={MenuLocation.Profile}
                    recipientCenterId={context.centerId}
                    patientTypeId={context.headerInfo.typeId}
                    voucherDonorId={context.headerInfo.voucherDonorId}
                    voucherDonorAlias={context.headerInfo.voucherDonorAlias}
                    voucherDonorCenterId={context.headerInfo.voucherDonorCenterId}
                    canOrderCheekSwab={context.headerInfo.canOrderCheekSwab}
                    canDelete={context.headerInfo.canDelete}
                    isWaitlistEligible={context.headerInfo.isWaitlistEligible}
                    micrositeRecipientId={context.headerInfo.micrositeRecipientId}
                    onMenuToggle={handleMenuToggle}
                    onItemSelected={handleAction}
                />
            </div>
        </div>
    );
}

export default RecipientProfileSaveRow;